var exports = {
  "N1": "ChannelHeader.module__headerContainer___ZUNyYU",
  "dL": "ChannelHeader.module__headerWrapper___ZUNyYU",
  "Hv": "ChannelHeader.module__headerWrapperCallActive___ZUNyYU",
  "hE": "ChannelHeader.module__headerContainerCallActive___ZUNyYU",
  "Pf": "ChannelHeader.module__callBannerRing___ZUNyYU",
  "Ud": "ChannelHeader.module__headerLeftSection___ZUNyYU",
  "Gv": "ChannelHeader.module__backButton___ZUNyYU",
  "wK": "ChannelHeader.module__backButtonDesktop___ZUNyYU" + " " + "ChannelHeader.module__backButton___ZUNyYU",
  "j2": "ChannelHeader.module__backIcon___ZUNyYU",
  "Ir": "ChannelHeader.module__backIconBold___ZUNyYU" + " " + "ChannelHeader.module__backIcon___ZUNyYU",
  "CY": "ChannelHeader.module__leftContentContainer___ZUNyYU",
  "Bn": "ChannelHeader.module__voiceCallHeaderSupplement___ZUNyYU",
  "BN": "ChannelHeader.module__mobileButton___ZUNyYU",
  "Vt": "ChannelHeader.module__desktopButton___ZUNyYU" + " " + "ChannelHeader.module__mobileButton___ZUNyYU",
  "R3": "ChannelHeader.module__avatarWrapper___ZUNyYU",
  "ax": "ChannelHeader.module__groupDmHeaderTrigger___ZUNyYU",
  "_D": "ChannelHeader.module__groupDmHeaderInner___ZUNyYU",
  "ab": "ChannelHeader.module__groupDmEditIcon___ZUNyYU",
  "HA": "ChannelHeader.module__channelName___ZUNyYU",
  "$7": "ChannelHeader.module__groupDmChannelName___ZUNyYU",
  "kf": "ChannelHeader.module__dmNameWrapper___ZUNyYU",
  "a1": "ChannelHeader.module__userTag___ZUNyYU",
  "p": "ChannelHeader.module__channelIcon___ZUNyYU",
  "ml": "ChannelHeader.module__caretRight___ZUNyYU",
  "Nj": "ChannelHeader.module__channelInfoContainer___ZUNyYU",
  "u8": "ChannelHeader.module__followButton___ZUNyYU",
  "B6": "ChannelHeader.module__topicDivider___ZUNyYU",
  "zm": "ChannelHeader.module__topicContainer___ZUNyYU",
  "yu": "ChannelHeader.module__topicButton___ZUNyYU",
  "Am": "ChannelHeader.module__topicButtonOverflow___ZUNyYU",
  "lY": "ChannelHeader.module__headerRightSection___ZUNyYU",
  "P0": "ChannelHeader.module__messageSearchFocusWrapper___ZUNyYU",
  "bS": "ChannelHeader.module__headerContainerThreadPanelOpen___ZUNyYU",
  "gb": "ChannelHeader.module__iconButton___ZUNyYU",
  "f5": "ChannelHeader.module__iconButtonDefault___ZUNyYU" + " " + "ChannelHeader.module__iconButton___ZUNyYU",
  "vR": "ChannelHeader.module__iconButtonSelected___ZUNyYU" + " " + "ChannelHeader.module__iconButton___ZUNyYU",
  "rB": "ChannelHeader.module__updateIconButton___ZUNyYU" + " " + "ChannelHeader.module__iconButton___ZUNyYU",
  "t4": "ChannelHeader.module__updateIconButtonDisabled___ZUNyYU" + " " + "ChannelHeader.module__updateIconButton___ZUNyYU" + " " + "ChannelHeader.module__iconButton___ZUNyYU",
  "l_": "ChannelHeader.module__updateIcon___ZUNyYU",
  "DW": "ChannelHeader.module__updateProgress___ZUNyYU",
  "IC": "ChannelHeader.module__iconButtonMobile___ZUNyYU",
  "iA": "ChannelHeader.module__buttonIcon___ZUNyYU",
  "qt": "ChannelHeader.module__buttonIconMobile___ZUNyYU",
  "Dm": "ChannelHeader.module__iconButtonWrapper___ZUNyYU",
  "W9": "ChannelHeader.module__unreadPinIndicator___ZUNyYU",
};

module.exports = exports;
